import { isPlatformBrowser } from '@angular/common';
import {Component, ElementRef, Inject, Injector, Input, OnChanges, OnInit, PLATFORM_ID, ViewChild, ViewEncapsulation} from '@angular/core';
import {UtilsService} from "../../services/utils.service";
import {BannerType} from '@shopping-angular-components/draper-banner/lib/model/BannerType';
import {ScreenType} from 'projects/common/model/ScreenType';
import { Module } from 'projects/common/model/ModuleModel';
import { LoaderComponent } from '@shopping-angular-components/loader';
import { FiltersService } from 'projects/common/services/filters.service';
import { DiscreteFilter, FilterValue } from '../offers-filters/offers-filters-model';
import { AbstractComponent } from '../abstract.component';

@Component({
  selector: 'draper-banner-wrapper',
  template: `
    <draper-banner #banner *ngIf="module.data && showBanner"
      [draperResponse]="module.data.banners"
      [inCluster]="false"
      [screenConfig]="{type: screenType}"
      [bannerType]="module.data.banner_type"
      [draperTrackingData]="draperTrackingData"
      [product]="'nymeria-gui'"
      [flow]="'landing'"
      [smallBanner]="module.data.small_banner"
      [showMargin]="false">
    </draper-banner>
  `,
  styleUrls: ['./draper-banner-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class DraperBannerWrapperComponent extends AbstractComponent implements OnInit, OnChanges {
  public static MODULE_ID: string = 'DraperBannerModule';
  @Input() override module: Module<DraperBannerModel>;
  draperTrackingData;
  override screenType: ScreenType;
  showBanner = true;
  private subscriptions: any[] = [];
  bannerCurrencyCode?: string;

  @ViewChild('banner') banner: ElementRef;

  constructor(injector: Injector, public utilsService: UtilsService,
    public filtersService: FiltersService,
    @Inject(PLATFORM_ID) private platformId: string) {
    super(injector);
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.draperTrackingData = {
        ...this.module.data.banners.context,
        ...globalThis.upaData
      }
      this.screenType = this.utilsService.getScreenType();

      window.addEventListener('payment-method-banner:switch-currency',(event: Event) => {
        const customEvent = event as CustomEvent;
        const currency = customEvent.detail.currency;
        if (this.module.data.apply_filter) {
          const filter = this.filtersService.filters['currency'] as DiscreteFilter;
          if (!filter) {
            console.log("Filter not found");
            return;
          }
          filter.values.forEach(value => {
            value.selected = value.id === currency;
          });
          this.filtersService.updateFiltersState(this.filtersService.filters, this.module.row_number, this.module.unique_id);
          this.filtersService.getSelectedFilterLabels();
          this.filtersService.applyFilter();
        } else {
          LoaderComponent.showLoaderEvent.emit(true);
          const url = new URL(window.location.href);
          url.searchParams.set('forceCurrencyCode', currency);
          window.location.href = url.toString();
        }
      });

      // chanchitoBanner con wheelBanner
      window.addEventListener('chanchitoCuponEvent', (event: Event) => {
        const customEvent = event as CustomEvent;
        switch (customEvent.detail.type) { 
          case 'userActivatedCoupon':
            window.location.reload(); break
          case 'filtered':
            this.handleCouponFilter(); break
          case 'unfiltered':
            this.handleCouponUnfilter(); break
        }
      });

      this.bannerCurrencyCode = this.module.data?.banners?.components?.find(c => c.incentive === "PAYMENT_METHOD_SWITCH" || c.component_subtype ===
         "choosePayment" || c.content?.currency)?.content?.currency;
    }
  }

  ngOnChanges(): void {
    const newBannerCurrencyCode = this.module.data?.banners?.components?.find(c => c.incentive === "PAYMENT_METHOD_SWITCH" || c.component_subtype ===
      "choosePayment" || c.content?.currency)?.content?.currency;

    if (this.bannerCurrencyCode !== newBannerCurrencyCode) {
      this.bannerCurrencyCode = newBannerCurrencyCode;
      this.reloadBanner();
    }
    
    if (this.module.data?.banner_type?.toString() == "chanchitoBanner") {
      this.reloadBanner()
    }
  }

  reloadBanner() {
    this.showBanner = false;
    setTimeout(() => {
      this.showBanner = true;
    }, 0);
  }

  handleCouponFilter() {
    const baseFilter = { type: 'discrete', multiselector: false, hasSelection: true, active: false, hidden: true, forceHidden: true, name: "Descuentos"}

    if (this.draperTrackingData.pr === 'activities') {
      const valueActivities: FilterValue = {id: 'ALL_VISIBLE', selected: true} as FilterValue;
      this.filtersService.filters['promotion_filter'] = {...baseFilter, values: [valueActivities]} as DiscreteFilter;
    } else {
      const valueHotels: FilterValue = {id: 'cross-selling', selected: true} as FilterValue;
      this.filtersService.filters['offers'] = {...baseFilter, values: [valueHotels]} as DiscreteFilter;
    }

    this.filtersService.updateFiltersState(this.filtersService.filters, this.module.row_number, this.module.unique_id);
    this.filtersService.getSelectedFilterLabels();
    this.filtersService.applyFilter();
  }

  handleCouponUnfilter() {
    if (this.draperTrackingData.pr === 'activities') {
      this.filtersService.unapplyFilter('promotion_filter', this.module.row_number, this.module.unique_id);
    } else {
      this.filtersService.unapplyFilter('offers', this.module.row_number, this.module.unique_id);
    }

    this.filtersService.updateFiltersState(this.filtersService.filters, this.module.row_number, this.module.unique_id);
  }

  getModuleId(): string {
    return DraperBannerWrapperComponent.MODULE_ID;
  }
}

export interface DraperBannerModel {
  banners: BannersModel,
  peggy: object,
  banner_type: BannerType,
  small_banner: boolean,
  apply_filter?: boolean,
}

interface BannersModel {
  context: {
    ip?: string,
    company_id?: string,
    userid?: string,
    event?: string,
    cc: string,
    ch: string,
    pr: string,
    fl: string,
    lan: string,
  },
  components: [{
    source: string,
    component_type: string,
    component_subtype: string,
    incentive: string,
    version: string,
    content: {
      currency?: string
    },
    tracking: object,
  }]
}
